import React from 'react';
import { Box, Typography, Card, CardContent } from '@mui/material';

const PrivacyPolicySettings = () => {








    
  return (
    <Box sx={{ maxWidth: 800, mx: 'auto', py: 3 }}>
      <Typography variant="h6" gutterBottom>
        Privacy & Policy Settings
      </Typography>
      <Typography variant="body2" color="text.secondary" paragraph>
        Manage your data privacy and account settings
      </Typography>

      {/* Data Privacy Settings */}
      <Card variant="outlined" sx={{ mb: 3 }}>
        <CardContent>
          <Typography variant="subtitle1" gutterBottom>
            Data Privacy
          </Typography>
          <Typography variant="body2" paragraph>
            Control how your personal information is used and shared.
          </Typography>
          {/* Add any privacy controls here */}
        </CardContent>
      </Card>

      {/* Communication Preferences */}
      <Card variant="outlined">
        <CardContent>
          <Typography variant="subtitle1" gutterBottom>
            Communication Preferences
          </Typography>
          <Typography variant="body2" paragraph>
            Manage email notifications and updates.
          </Typography>
          {/* Add communication preferences controls here */}
        </CardContent>
      </Card>
    </Box>
  );
};

export default PrivacyPolicySettings;
